import { useEffect } from "react";
import { pushToDataLayer } from "utils/datalayer";

// hook to populate datalayer on first render
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAddToDataLayer = (data: any) => {
  useEffect(() => {
    pushToDataLayer(data);
  }, []);
};
